import React, { useState } from 'react';
import { Card, Row, Col, Button, Typography, Space, Modal, Upload, Pagination, message, Input, Tooltip, Segmented, Table, Drawer } from 'antd';
import { UploadOutlined, EditOutlined, DownloadOutlined, DeleteOutlined, ExclamationCircleOutlined, EyeOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;
const { confirm } = Modal;

const mockTags = [
  { id: '1', name: 'label_35479094', image: 'https://via.placeholder.com/300x200?text=DID:12332423ggg' },
  { id: '2', name: 'label_40516405', image: 'https://via.placeholder.com/300x200?text=QC01+Power:24' },
  { id: '3', name: 'label_35479094', image: 'https://via.placeholder.com/300x200?text=DID:12332423ggg' },
  { id: '4', name: 'ecosystem-platform-CS37eJ33q', image: 'https://via.placeholder.com/300x200?text=CID:7898899' },
  { id: '5', name: '7472', image: 'https://via.placeholder.com/300x200?text=CID:7898899+QC' },
  { id: '6', name: '标签6111', image: 'https://via.placeholder.com/300x200?text=CID:7898899' },
  { id: '7', name: 'label_99001', image: 'https://via.placeholder.com/300x200?text=SN:ABC123' },
  { id: '8', name: 'tag_demo_01', image: 'https://via.placeholder.com/300x200?text=DEMO+TAG' },
];

const mockEnterprises = [
  {
    id: 'ENT001',
    name: '杭州万物互联有限公司',
    tags: [
      { id: 'e1-1', name: 'label_35479094', image: 'https://via.placeholder.com/300x200?text=DID:12332423ggg' },
      { id: 'e1-2', name: 'label_40516405', image: 'https://via.placeholder.com/300x200?text=QC01+Power:24' },
      { id: 'e1-3', name: 'label_35479094', image: 'https://via.placeholder.com/300x200?text=DID:12332423ggg' },
      { id: 'e1-4', name: 'ecosystem-platform-CS37eJ33q', image: 'https://via.placeholder.com/300x200?text=CID:7898899' },
      { id: 'e1-5', name: '7472', image: 'https://via.placeholder.com/300x200?text=CID:7898899+QC' },
      { id: 'e1-6', name: '标签6111', image: 'https://via.placeholder.com/300x200?text=CID:7898899' },
      { id: 'e1-7', name: 'label_99001', image: 'https://via.placeholder.com/300x200?text=SN:ABC123' },
      { id: 'e1-8', name: 'tag_demo_01', image: 'https://via.placeholder.com/300x200?text=DEMO+TAG' },
    ],
  },
  {
    id: 'ENT002',
    name: '深圳智能制造科技有限公司',
    tags: [
      { id: 'e2-1', name: 'label_40516405', image: 'https://via.placeholder.com/300x200?text=QC01+Power:24' },
      { id: 'e2-2', name: 'tag_demo_01', image: 'https://via.placeholder.com/300x200?text=DEMO+TAG' },
      { id: 'e2-3', name: 'label_99001', image: 'https://via.placeholder.com/300x200?text=SN:ABC123' },
    ],
  },
  {
    id: 'ENT003',
    name: '东莞电子制造有限公司',
    tags: [
      { id: 'e3-1', name: '7472', image: 'https://via.placeholder.com/300x200?text=CID:7898899+QC' },
      { id: 'e3-2', name: '标签6111', image: 'https://via.placeholder.com/300x200?text=CID:7898899' },
      { id: 'e3-3', name: 'ecosystem-platform-CS37eJ33q', image: 'https://via.placeholder.com/300x200?text=CID:7898899' },
    ],
  },
];

const DeviceTag = () => {
  // 身份切换：enterprise=企业用户 / platform=平台用户
  const [identity, setIdentity] = useState('enterprise');

  const [importVisible, setImportVisible] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [editingTag, setEditingTag] = useState(null); // { tag, enterpriseId }
  const [editName, setEditName] = useState('');
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [current, setCurrent] = useState(1);
  const pageSize = 8;

  // 平台用户状态
  const [enterprises, setEnterprises] = useState(mockEnterprises);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [currentViewEnterprise, setCurrentViewEnterprise] = useState(null);
  const [drawerCurrent, setDrawerCurrent] = useState(1);

  const pagedData = mockTags.slice((current - 1) * pageSize, current * pageSize);
  const currentTags = currentViewEnterprise ? currentViewEnterprise.tags : [];
  const drawerPaged = currentTags.slice((drawerCurrent - 1) * pageSize, drawerCurrent * pageSize);

  const handleDelete = (tag) => {
    confirm({
      title: '确认删除',
      icon: <ExclamationCircleOutlined style={{ color: '#ff4d4f' }} />,
      content: <span>确定删除标签 <Text strong>{tag.name}</Text> 吗？删除后不可恢复。</span>,
      okText: '确认删除',
      okButtonProps: { danger: true },
      cancelText: '取消',
      onOk() {
        if (currentViewEnterprise) {
          setEnterprises(prev => prev.map(en =>
            en.id === currentViewEnterprise.id
              ? { ...en, tags: en.tags.filter(t => t.id !== tag.id) }
              : en
          ));
        }
        message.success('已删除');
      },
    });
  };

  const handleEdit = (tag) => {
    setEditingTag({ tag, enterpriseId: currentViewEnterprise?.id ?? null });
    setEditName(tag.name);
    setEditVisible(true);
  };

  const handleEditSave = () => {
    if (editingTag?.enterpriseId) {
      setEnterprises(prev => prev.map(en =>
        en.id === editingTag.enterpriseId
          ? { ...en, tags: en.tags.map(t => t.id === editingTag.tag.id ? { ...t, name: editName } : t) }
          : en
      ));
    }
    message.success('标签名称已更新');
    setEditVisible(false);
  };

  const handleImport = () => {
    if (currentViewEnterprise) {
      const newTags = [
        {
          id: `import_${Date.now()}`,
          name: `label_${Math.floor(Math.random() * 90000 + 10000)}`,
          image: 'https://via.placeholder.com/300x200?text=IMPORTED',
        },
      ];
      setEnterprises(prev => prev.map(en =>
        en.id === currentViewEnterprise.id
          ? { ...en, tags: [...en.tags, ...newTags] }
          : en
      ));
    }
    message.success('标签导入成功');
    setImportVisible(false);
  };

  // 卡片渲染（企业用户与平台用户抽屉共用）
  const renderTagCards = (tags) => (
    <Row gutter={[16, 16]}>
      {tags.map(tag => (
        <Col key={tag.id} xs={24} sm={12} md={8} lg={6}>
          <Card
            hoverable
            bodyStyle={{ padding: 0 }}
            style={{ borderRadius: 8, overflow: 'hidden' }}
            cover={
              <div
                style={{ height: 180, background: '#fafafa', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', position: 'relative' }}
                onClick={() => { setPreviewImage(tag.image); setPreviewVisible(true); }}
              >
                <img src={tag.image} alt={tag.name} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0)', transition: 'all 0.3s', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                  onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(0,0,0,0.4)'}
                  onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(0,0,0,0)'}
                >
                  <EyeOutlined style={{ fontSize: 24, color: '#fff', opacity: 0, transition: 'all 0.3s' }}
                    onMouseEnter={(e) => e.currentTarget.style.opacity = 1}
                    onMouseLeave={(e) => e.currentTarget.style.opacity = 0}
                  />
                </div>
              </div>
            }
          >
            <div style={{ padding: '10px 12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '1px solid #f0f0f0' }}>
              <Tooltip title={tag.name}>
                <Text ellipsis style={{ maxWidth: 140, fontSize: 13 }}>{tag.name}</Text>
              </Tooltip>
              <Space size={4}>
                <Button type="text" size="small" icon={<EditOutlined />} onClick={() => handleEdit(tag)} />
                <Button type="text" size="small" icon={<DownloadOutlined />} onClick={() => message.success('下载中...')} />
                <Button type="text" size="small" danger icon={<DeleteOutlined />} onClick={() => handleDelete(tag)} />
              </Space>
            </div>
          </Card>
        </Col>
      ))}
    </Row>
  );

  const platformColumns = [
    {
      title: '所属企业',
      dataIndex: 'name',
      key: 'name',
      render: (_, record) => (
        <div>
          <div>{record.name}</div>
          <div style={{ color: '#999', fontSize: 12 }}>{record.id}</div>
        </div>
      ),
    },
    {
      title: '标签数量',
      dataIndex: 'tags',
      key: 'count',
      render: (tags) => tags.length,
    },
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <Button type="link" icon={<EyeOutlined />} onClick={() => {
          setCurrentViewEnterprise(record);
          setDrawerCurrent(1);
          setDrawerVisible(true);
        }}>查看标签</Button>
      ),
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      {/* 顶部：标题 + 导入入口（企业用户）+ mock身份切换 */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <Title level={4} style={{ margin: 0 }}>设备标签</Title>
        <Space size={12}>
          {identity === 'enterprise' && (
            <Button type="primary" icon={<UploadOutlined />} onClick={() => setImportVisible(true)}>导入标签</Button>
          )}
          <Space size={4}>
            <Text>mock身份</Text>
            <Segmented
              value={identity}
              onChange={setIdentity}
              options={[
                { label: '企业用户', value: 'enterprise' },
                { label: '平台用户', value: 'platform' },
              ]}
            />
          </Space>
        </Space>
      </div>

      {identity === 'enterprise' ? (
        <>
          {/* 企业用户：标签卡片 */}
          {renderTagCards(pagedData)}

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 16 }}>
            <Text type="secondary">共 {mockTags.length} 条记录</Text>
            <Pagination current={current} total={mockTags.length} pageSize={pageSize} onChange={setCurrent} showSizeChanger={false} />
          </div>
        </>
      ) : (
        <>
          {/* 平台用户：一级企业列表 */}
          <Table
            columns={platformColumns}
            dataSource={enterprises}
            rowKey="id"
            pagination={{
              pageSize: 10,
              showTotal: (total) => `共 ${total} 家企业`,
            }}
          />
        </>
      )}

      {/* 平台用户：查看标签抽屉（60%宽） */}
      <Drawer
        title={currentViewEnterprise ? `${currentViewEnterprise.name} - 标签` : '标签'}
        width="60%"
        open={drawerVisible}
        onClose={() => setDrawerVisible(false)}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <Text type="secondary">共 {currentTags.length} 个标签</Text>
          <Button type="primary" icon={<UploadOutlined />} onClick={() => setImportVisible(true)}>导入标签</Button>
        </div>

        {renderTagCards(drawerPaged)}

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
          <Pagination current={drawerCurrent} total={currentTags.length} pageSize={pageSize} onChange={setDrawerCurrent} showSizeChanger={false} />
        </div>
      </Drawer>

      {/* 导入标签 */}
      <Modal title="导入标签" open={importVisible} onOk={handleImport} onCancel={() => setImportVisible(false)} okText="导入" cancelText="取消" destroyOnClose width={480}>
        <Upload.Dragger multiple beforeUpload={() => false} accept=".png,.jpg,.jpeg,.svg,.pdf" style={{ marginTop: 16 }}>
          <p className="ant-upload-drag-icon"><UploadOutlined style={{ fontSize: 32, color: '#1890ff' }} /></p>
          <p className="ant-upload-text">点击或拖拽标签文件至此处上传</p>
          <p className="ant-upload-hint">支持 png、jpg、svg、pdf 格式，可批量上传</p>
        </Upload.Dragger>
      </Modal>

      {/* 编辑标签名称 */}
      <Modal title="编辑标签名称" open={editVisible} onOk={handleEditSave} onCancel={() => setEditVisible(false)} okText="保存" cancelText="取消" destroyOnClose width={400}>
        <div style={{ marginTop: 16 }}>
          <Text type="secondary" style={{ display: 'block', marginBottom: 8 }}>标签名称</Text>
          <Input value={editName} onChange={(e) => setEditName(e.target.value)} placeholder="请输入标签名称" />
        </div>
      </Modal>

      {/* 图片预览 */}
      <Modal open={previewVisible} footer={null} onCancel={() => setPreviewVisible(false)} width={600} centered>
        <img src={previewImage} alt="preview" style={{ width: '100%' }} />
      </Modal>
    </div>
  );
};

export default DeviceTag;
